import { RefObject, useCallback, useEffect, useState } from 'react'

/**
 * useToolbarScroll
 * author: soojin.oh
 */

// hook
const useToolbarScroll = (scrollTarget?: RefObject<HTMLDivElement>) => {
  const [hasShadow, setShadow] = useState(false)
  const onScroll = useCallback(() => {
    if (scrollTarget) {
      setShadow((scrollTarget.current?.scrollTop || 0) > 0)
    } else {
      setShadow(document.documentElement.scrollTop > 0)
    }
  }, [scrollTarget, scrollTarget?.current])
  useEffect(() => {
    if (!scrollTarget) {
      window.addEventListener('scroll', onScroll)
      return () => window.removeEventListener('scroll', onScroll)
    } else {
      scrollTarget.current?.addEventListener('scroll', onScroll)
      return () => scrollTarget.current?.removeEventListener('scroll', onScroll)
    }
  }, [scrollTarget, scrollTarget?.current, onScroll])

  return {
    hasShadow,
  }
}

export default useToolbarScroll
